<template>
  <div class="admin-panel-page-wrapper">
    <admin-panel-header />
    <v-toolbar class="escalon-bb sub-toolbar secondary" height="40px">
      <v-toolbar-title class="welcome-user-practice">{{this.axisTitle}}</v-toolbar-title>
    </v-toolbar>
    <Admin-Panel-Dashboard v-if="this.showTab == AdminPanelTabs.DashBoard"
    @clickedGoToReports="goToReport"/>
    <Admin-Panel-Reports v-else-if="this.showTab == AdminPanelTabs.Reports"
    @clickedGoToDashboard="goToDashboard"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import adminPanelHeader from "../components/adminPanel/AdminPanelHeader";
import {AdminPanelTabs} from "../config/config.js";
import AdminPanelDashboard from "../components/adminPanel/AdminPanelDashboard";
import AdminPanelReports from "../components/adminPanel/AdminPanelReports";
export default {
  components: {
    adminPanelHeader,
    AdminPanelDashboard,
    AdminPanelReports
  },
  data(){
    return{ 
      AdminPanelTabs: AdminPanelTabs,    
      showTab: AdminPanelTabs.DashBoard
    }
  },
  methods:{
    goToReport(){
      this.showTab = AdminPanelTabs.Reports;
    },
    goToDashboard(){
      this.showTab = AdminPanelTabs.DashBoard;
    }
  },
  computed: {
    ...mapGetters(["axisTitle"]),
  }
}
</script>